import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageSEO from '@/components/base/PageSEO';
import { hotHeadlines, latestArticles, featuredArticle } from '@/mocks/articles';

const allArticles = [featuredArticle, ...hotHeadlines, ...latestArticles];

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = allArticles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen flex items-center justify-center pt-20">
          <div className="text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-950 mb-4">文章未找到</h1>
            <p className="text-foreground-600 mb-6">该文章可能已被删除或链接无效</p>
            <Link to="/" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer">
              <i className="ri-arrow-left-line"></i>返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    image: article.image,
    datePublished: article.date,
    author: {
      '@type': 'Organization',
      name: '51黑料网',
      url: 'http://3kyzh.com/',
    },
    publisher: {
      '@type': 'Organization',
      name: '51黑料网',
      url: 'http://3kyzh.com/',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `http://3kyzh.com/article/${article.slug}`,
    },
  };

  return (
    <>
      <PageSEO
        title={`${article.title} - 51黑料网`}
        description={article.excerpt}
        keywords={`51黑料网,${article.category},黑料爆料,吃瓜事件,热门爆料`}
        canonical={`http://3kyzh.com/article/${article.slug}`}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      />
      <Navbar />
      <main className="pt-20 md:pt-24">
        <article className="max-w-4xl mx-auto px-4 md:px-6 py-8">
          <nav className="text-xs text-foreground-500 mb-6 flex items-center gap-2 flex-wrap">
            <Link to="/" className="hover:text-foreground-700 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to={`/category/${article.categorySlug}`} className="hover:text-foreground-700 transition-colors cursor-pointer">{article.category}</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700">{article.title}</span>
          </nav>

          <header className="mb-8">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              {article.category}
            </span>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              {article.title}
            </h1>
            <div className="flex items-center gap-4 text-sm text-foreground-500">
              <span className="flex items-center gap-1.5"><i className="ri-time-line"></i>{article.date}</span>
              <span className="flex items-center gap-1.5"><i className="ri-eye-line"></i>{article.views} 阅读</span>
              {article.comments && (
                <span className="flex items-center gap-1.5"><i className="ri-chat-3-line"></i>{article.comments.toLocaleString()} 评论</span>
              )}
            </div>
          </header>

          <div className="rounded-2xl overflow-hidden mb-8">
            <img src={article.image} alt={article.title} className="w-full h-auto object-cover" />
          </div>

          <div className="prose prose-lg max-w-none">
            <p className="text-foreground-700 leading-relaxed mb-4">
              {article.excerpt}
            </p>
            <p className="text-foreground-700 leading-relaxed mb-4">
              据多方消息源证实，此事在圈内已经传得沸沸扬扬。多位知情人士向本网透露，事件背后的内情远比表面看到的更加复杂。涉事多方目前均保持沉默，但已有大量证据在社交媒体上流传。
            </p>
            <p className="text-foreground-700 leading-relaxed mb-4">
              业内人士分析指出，如果相关爆料属实，这将是今年娱乐圈最重磅的事件之一。目前已有多个品牌方表示正在密切关注事态发展，不排除调整相关合作计划的可能性。
            </p>
            <p className="text-foreground-700 leading-relaxed mb-4">
              本网将持续跟踪报道此事件的后续发展，敬请关注。同时也提醒广大吃瓜群众，在信息尚未完全明朗之前，请保持理性态度，不传播未经证实的消息。
            </p>
            {article.tags && (
              <div className="flex flex-wrap items-center gap-2 mt-8 pt-6 border-t border-background-200/70">
                {article.tags.map((tag) => (
                  <span key={tag} className="px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-xs">
                    #{tag}
                  </span>
                ))}
              </div>
            )}
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer">
              <i className="ri-arrow-left-line"></i>返回首页查看更多爆料
            </Link>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}
